import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { DeviceCardProps } from './types';
import { LABELS } from './constants';
import {
  StyledDeviceCard,
  DeviceCardContent,
  DeviceCardHeader,
  DeviceCardInfo,
  DeviceCardTitle,
  DeviceCardIdentifier,
  DeviceTypeBadge,
  DeviceCardDivider,
  DeviceCardActions,
  IconButtonStyled,
  DangerButton,
} from './styles';

export const DeviceCard: React.FC<DeviceCardProps> = ({
  device,
  isDark,
  onEdit,
  onDelete,
}) => {
  const deviceTypeName = typeof device.type === 'object' ? device.type?.name : 'Unknown';

  return (
    <StyledDeviceCard $isDark={isDark}>
      <DeviceCardContent>
        <DeviceCardHeader>
          <DeviceCardInfo>
            <DeviceCardTitle $isDark={isDark}>
              {device.name}
            </DeviceCardTitle>
            <DeviceCardIdentifier $isDark={isDark}>
              {device.identifier}
            </DeviceCardIdentifier>
          </DeviceCardInfo>
          <DeviceTypeBadge $isDark={isDark}>
            {deviceTypeName}
          </DeviceTypeBadge>
        </DeviceCardHeader>

        <DeviceCardDivider $isDark={isDark} />

        <DeviceCardActions>
          <Tooltip title={LABELS.EDIT_DEVICE}>
            <IconButtonStyled
              $isDark={isDark}
              $color={isDark ? '#90cdf4' : '#3182ce'}
              type="text"
              icon={<FontAwesomeIcon icon={faEdit} />}
              onClick={() => onEdit(device)}
            />
          </Tooltip>
          <Tooltip title={LABELS.DELETE_DEVICE}>
            <DangerButton
              type="text"
              icon={<FontAwesomeIcon icon={faTrash} />}
              onClick={() => onDelete(device.id)}
            />
          </Tooltip>
        </DeviceCardActions>
      </DeviceCardContent>
    </StyledDeviceCard>
  );
};
